import React from 'react';
import { Tabs, TabsList, TabsTrigger } from '../../../components/ui/tabs';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../../../components/ui/select';
import { LineChart, BarChart2, AreaChart } from 'lucide-react';
import { fmtPeriodo } from './kpiUtils';

const MonthSelect = ({ value, onChange, periodos, testId }) => (
  <Select value={value || ''} onValueChange={onChange}>
    <SelectTrigger className="h-9 w-[140px]" data-testid={testId}><SelectValue placeholder="Mes" /></SelectTrigger>
    <SelectContent>
      {[...periodos].reverse().map((p) => (
        <SelectItem key={p} value={p}>{fmtPeriodo(p)}</SelectItem>
      ))}
    </SelectContent>
  </Select>
);

const CHART_TYPES = [
  { id: 'linea', label: 'Línea', icon: LineChart },
  { id: 'barras', label: 'Barras', icon: BarChart2 },
  { id: 'area', label: 'Área', icon: AreaChart },
];

export const ChartTypeToggle = ({ value, onChange }) => (
  <div className="inline-flex rounded-lg border border-slate-200 dark:border-slate-700 p-0.5 bg-slate-50 dark:bg-slate-800" data-testid="chart-type-toggle">
    {CHART_TYPES.map((t) => {
      const Icon = t.icon;
      const active = value === t.id;
      return (
        <button
          key={t.id}
          onClick={() => onChange(t.id)}
          aria-label={t.label}
          title={t.label}
          className={`p-1.5 rounded-md active:scale-95 transition-transform ${
            active ? 'bg-white dark:bg-slate-900 shadow-sm text-indigo-600' : 'text-slate-400 hover:text-slate-600'
          }`}
          data-testid={`chart-type-${t.id}`}
        >
          <Icon className="h-4 w-4" />
        </button>
      );
    })}
  </div>
);

export const ViewControls = ({
  view, onView, chartType, onChartType, periodos = [],
  mesUno, onMesUno, mesA, onMesA, mesB, onMesB, showChartType = true,
}) => (
  <div className="flex flex-col sm:flex-row sm:items-center gap-3 flex-wrap">
    <Tabs value={view} onValueChange={onView}>
      <TabsList data-testid="kpi-view-tabs">
        <TabsTrigger value="evolucion" data-testid="tab-evolucion">Evolución</TabsTrigger>
        <TabsTrigger value="un-mes" data-testid="tab-un-mes">Un mes</TabsTrigger>
        <TabsTrigger value="comparar" data-testid="tab-comparar">Comparar</TabsTrigger>
      </TabsList>
    </Tabs>

    {view === 'un-mes' && (
      <MonthSelect value={mesUno} onChange={onMesUno} periodos={periodos} testId="mes-uno-select" />
    )}
    {view === 'comparar' && (
      <div className="flex items-center gap-2">
        <MonthSelect value={mesA} onChange={onMesA} periodos={periodos} testId="mes-a-select" />
        <span className="text-slate-400 text-sm font-medium">vs</span>
        <MonthSelect value={mesB} onChange={onMesB} periodos={periodos} testId="mes-b-select" />
      </div>
    )}
    {showChartType && view !== 'comparar' && (
      <div className="sm:ml-auto"><ChartTypeToggle value={chartType} onChange={onChartType} /></div>
    )}
  </div>
);
